import { ChangeDetectionStrategy, Component, OnInit, computed, inject, input, output } from '@angular/core';
import { from } from 'rxjs';
import { concatMap, toArray } from 'rxjs/operators';
import { HierarchyService } from 'src/app/core/hierarchy.service';
import { PosizioniService } from 'src/app/core/posizioni.service';
import { Posizione } from 'src/app/shared/models/posizione.model';

@Component({
  selector: 'app-tabella-copiaper',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (copie$() | async; as posizioni) {
    <p-table [value]="posizioni" [autoLayout]="true">
      <ng-template pTemplate="header">
        <tr>
          @for(level of hierarchy; track $index) {
          <th>{{level}}</th>
          }
          <th>Descrizione</th>
          @if (canModified()) {
            <th style="width: 50px;">Elimina</th>
          }
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-copiaper>
        <tr>
          @for(level of hierarchy; track $index) {
          <td>{{ copiaper[$index] ? copiaper[$index].sigla : '-' }}</td>
          }
          <td>{{ copiaper[descriptionIndex].descrizione }}</td>
          @if (canModified()) {
            <td style="text-align: center">
              <button pButton type="button" icon="fas fa-fw fa-trash" class="p-button-danger" title="Elimina copia"
                (click)="delete.emit(copiaper[copiaper.length - 1])"></button>
            </td>
          }
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="7">
            Non sono state trovate copie per il documento corrente
          </td>
        </tr>
      </ng-template>
    </p-table>
    }
  `
})
export class TabellaCopiaperComponent implements OnInit {
  copie = input<string[]>();
  canModified = input<boolean>(true);
  delete = output<Posizione>();

  copie$ = computed(() => {
    const copie = this.copie();
    if (!copie) return;
    return from(copie).pipe(
      concatMap((copia: string) => this.posizioniService.getAncestor(copia)),
      toArray()
    )
  });

  public hierarchy!: string[];
  public descriptionIndex!: number;

  private readonly posizioniService = inject(PosizioniService);
  private readonly hierarchyService = inject(HierarchyService);

  ngOnInit(): void {
    this.hierarchy = this.hierarchyService.getHierarchyLabels();
    this.descriptionIndex = this.hierarchyService.getDescriptionIndex();
  }
}
